<div class="displayname-wrapper">
	<div class="header-container">
		<div class="background-header" [attr.data-motion-opacity]="(frameMotion$ | async).direction"></div>
		<img
			class="back-button"
			*ngIf="!form.dirty"
			[src]="'./assets/Back Button (Blue-White).svg' | resolveAsset"
			appCrossPointerEventTarget
			(pointerClickEvent)="back.emit()" />
		<div class="back-button" appCrossPointerEventTarget (pointerClickEvent)="back.emit()" *ngIf="form.dirty">Cancel</div>
		<div class="displayname-header-text" [attr.data-motion-translate]="(frameMotion$ | async).direction">Change Display Name</div>
		<div class="save-button" *ngIf="isSaveButton">
			<app-gradient-button [width]="'85px'" [minHeight]="'30px'" [fontSize]="'14px'" [cursor]="'pointer'" (buttonClick)="updateDisplayname()"
				>Save
				<mat-spinner *ngIf="false" [color]="'accent'" [diameter]="30"></mat-spinner>
			</app-gradient-button>
		</div>
	</div>
	<div class="displayname-content" [attr.data-motion-translate]="(frameMotion$ | async).direction">
		<div>
			<app-input
				[formGroup]="form"
				[controlName]="form.get('firstName')"
				[input_label]="'First name'"
				[input_type]="'text'"
				[width]="'250px'"></app-input>
			<div class="error" *ngIf="errorMessage$ | async as error">{{ error }}</div>
		</div>
		<div>
			<app-input
				[formGroup]="form"
				[controlName]="form.get('lastName')"
				[input_label]="'Last name'"
				[input_type]="'text'"
				[width]="'250px'"></app-input>
		</div>

		<div class="save-mobile" *ngIf="isSaveButton">
			<app-gradient-button [width]="'85px'" [minHeight]="'30px'" [fontSize]="'14px'" [cursor]="'pointer'" (buttonClick)="updateDisplayname()">
				Save
				<mat-spinner *ngIf="false" [color]="'accent'" [diameter]="30"></mat-spinner>
			</app-gradient-button>
		</div>
	</div>
</div>
